import { forwardRef } from "react";

import {
  SONNER_CLOSE_CLASS,
  SONNER_DEFAULTS,
  type TSonnerCloseProps,
} from "@/ui/components/feedback/Sonner/Sonner.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { cn } from "@/ui/lib/utils";

export const SonnerClose = forwardRef<HTMLButtonElement, TSonnerCloseProps>(
  (
    {
      className,
      type = "button",
      "aria-label": ariaLabel = SONNER_DEFAULTS.dismissLabel,
      ...props
    },
    ref,
  ) => (
    <button
      {...props}
      ref={ref}
      type={type}
      aria-label={ariaLabel}
      data-component="SonnerClose"
      className={cn(SONNER_CLOSE_CLASS, className)}
    >
      <Icon icon="cross" size="sm" aria-hidden="true" />
    </button>
  ),
);

SonnerClose.displayName = "SonnerClose";
